var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  height: 100%;\n  color: ', ';\n'], ['\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  height: 100%;\n  color: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  font-size: 2.5rem;\n  line-height: 3rem;\n  padding: 0 5px;\n'], ['\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  font-size: 2.5rem;\n  line-height: 3rem;\n  padding: 0 5px;\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 100%:\n  padding: 0 5px;\n'], ['\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 100%:\n  padding: 0 5px;\n']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n  margin-top: 0.3rem;\n  font-size: 1rem;\n'], ['\n  margin-top: 0.3rem;\n  font-size: 1rem;\n']),
    _templateObject5 = _taggedTemplateLiteralLoose(['\n  ', '\n  border-left: 0.5rem solid transparent;\n  border-right: 0.5rem solid transparent\n'], ['\n  ', '\n  border-left: 0.5rem solid transparent;\n  border-right: 0.5rem solid transparent\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from 'react';
import styled from 'styled-components';

var NumericContent = styled.div(_templateObject, function (props) {
  return props.color;
});

var Number = styled.div(_templateObject2);

var ScaleAndIndicatorContainer = styled.div(_templateObject3);

var Scale = styled.div(_templateObject4);

var Indicator = styled.div(_templateObject5, function (props) {
  return props.indicator === 'Up' ? 'border-bottom: 0.625rem solid' : 'border-top: 0.625rem solid';
});

var Numeric = function Numeric(_ref) {
  var number = _ref.number,
      scale = _ref.scale,
      indicator = _ref.indicator,
      color = _ref.color,
      icon = _ref.icon;
  return React.createElement(
    NumericContent,
    { color: color },
    icon,
    React.createElement(
      Number,
      null,
      number
    ),
    React.createElement(
      ScaleAndIndicatorContainer,
      null,
      indicator === 'Up' || indicator === 'Down' ? React.createElement(Indicator, { indicator: indicator }) : null,
      React.createElement(
        Scale,
        null,
        scale
      )
    )
  );
};

export default Numeric;